<template>
  <a class="mr-2" @click="triggerAttribute">
    <slot>
      <a variant="default" size="small">
        <MIcon name="eye" class="cursor-pointer text-primary" />
      </a>
    </slot>
    <FlotoDrawer
      width="55%"
      :open="isDrawerOpen"
      class="flex"
      @hide="handleDrawerHide"
    >
      <template v-slot:title>
        {{ $tc('attribute', 2) }}
      </template>
      <template v-slot:trigger>
        <span />
      </template>
      <!-- <SelectedBaselineAttributeList :items="attributes" baseline-history /> -->
      <BaselineAttributeComponent :value="attributes" disabled />
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $tc('done') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
import BaselineAttributeComponent from '@components/baseline-attribute-component/baseline-attribute-component'
// import SelectedBaselineAttributeList from '@components/baseline-attribute-component/selected-baseline-attribute-list'
export default {
  name: 'BaselineListAttributeDrawer',
  components: {
    // SelectedBaselineAttributeList
    BaselineAttributeComponent,
  },
  props: {
    attributes: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      isDrawerOpen: false,
    }
  },
  methods: {
    handleDrawerHide() {
      this.isDrawerOpen = false
    },
    triggerAttribute() {
      this.$emit('trigger')
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 400)
    },
  },
}
</script>
